import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["intent"];
import * as React from 'react';
import cn from 'classnames';
import { Popup, PopupTriggerType } from '../../popup';
import { intentClass, Intent } from '../../../library';
export var tooltipClasses = {
  MAIN: 'tooltip'
};
export var Tooltip = function Tooltip(props) {
  var intent = props.intent,
    passProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(tooltipClasses.MAIN, intentClass(intent));
  return React.createElement(Popup, _extends({
    popupClassName: classNames
  }, passProps), props.children);
};
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  trigger: PopupTriggerType.HOVER_TARGET,
  intent: Intent.NONE,
  transitionDuration: 250
};